// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.


export const fileTypeLimitsDto = {
    fileType: 'fileType',
    maxFiles: 'maxFiles',
} as const;

export type TFileTypeLimitsDto = (typeof fileTypeLimitsDto)[keyof typeof fileTypeLimitsDto];

export interface IFileTypeLimitsDto {
    [fileTypeLimitsDto.fileType]: string | null;
    [fileTypeLimitsDto.maxFiles]: number | null;
}

export class FileTypeLimitsDto
    implements IFileTypeLimitsDto
{
    [fileTypeLimitsDto.fileType]: string | null = null;
    [fileTypeLimitsDto.maxFiles]: number | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IFileTypeLimitsData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[fileTypeLimitsDto.guid] = modelData[filetypelimitsData.guid];
    }

    static create(modelData?: any | null): IFileTypeLimitsDto | null {
        return modelData ? new FileTypeLimitsDto(modelData) : null;
    }
}
